import { rbac } from "config/rbac";
import { useCheckPerms } from "./useCheckPerms";

export const useIsAdmin = () => useCheckPerms(rbac.manageAdmin);
